import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { MobileHeaderRegistration, MobileHeaderView } from "./MobileHeader";
const TITLES = {
  "/dashboard": "Home",
  "/discover": "Discover",
  "/chats": "Messages",
  "/profile": "Profile",
  "/settings": "Settings",
  "/notifications": "Notifications",
  "/funds": "Your funds",
  "/bank-payouts": "Bank & Payouts",
  "/post-job": "Post a job",
  "/jobs": "Job details",
  "/my-applications": "My applications",
  "/subscription-plan": "Membership plans",
  "/admin/approvals": "Job approvals",
  "/verify-payment": "Payment status",
  "/account-activity": "Notifications",
  "/delete-account": "Delete account",
  "/apply-challenge": "Challenge",
  "/create-challenge": "Create challenge",
};
export default function MobilePageLayout({ children }) {
  const { pathname } = useLocation();
  const [registered, setRegistered] = useState(null);
  const register = useCallback(
    (id, props) => {
      setRegistered({ id, props, pathname });
      return () =>
        setRegistered((current) => (current?.id === id ? null : current));
    },
    [pathname],
  );
  const nativeChat = /^\/(chat|group-chat|community)\/[^/]+/.test(pathname);
  const title =
    TITLES[pathname] ||
    TITLES[pathname.replace(/\/[^/]+$/, "")] ||
    pathname
      .split("/")[1]
      ?.replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase()) ||
    "Zylen";
  const authPage = [
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
    "/otp-verification",
  ].includes(pathname);
  const marketPage =
    [
      "/dashboard",
      "/discover",
      "/settings",
      "/notifications",
      "/funds",
      "/bank-payouts",
      "/post-job",
      "/my-applications",
      "/admin/approvals",
      "/verify-payment",
    ].includes(pathname) || pathname.startsWith("/jobs/");
  const primary = ["/dashboard", "/discover", "/chats", "/profile"].includes(
    pathname,
  );
  const defaults = { title, isBackBtn: !primary };
  const props =
    registered?.pathname === pathname
      ? {
          ...defaults,
          ...Object.fromEntries(
            Object.entries(registered.props).filter(
              ([, value]) => value !== undefined,
            ),
          ),
        }
      : defaults;
  return (
    <MobileHeaderRegistration.Provider value={register}>
      <div
        className="app-mobile-frame"
        data-auth={authPage ? "true" : undefined}
        data-surface={marketPage ? "market" : undefined}
        data-native-chat={nativeChat ? "true" : undefined}
      >
        {!nativeChat && <MobileHeaderView {...props} />}
        <div className="app-mobile-screen">{children}</div>
      </div>
    </MobileHeaderRegistration.Provider>
  );
}
